<template>
  <div>
    <div
      class="box-form-result"
      v-if="!chiTietNguoiDung.userCanBoDepartmentDefaultId"
    >
      <div class="form-title mb-0 text-center text-danger">
        <b-icon icon="exclamation-circle-fill" variant="danger"></b-icon>
        Không thể phân quyền do người dùng chưa được gán cán bộ, hoặc cán bộ
        chưa thuộc đơn vị nào
      </div>
    </div>
    <div class="box-form-result" v-else>
      <div class="form-title">Danh sách quyền của người dùng</div>
      <p class="color-gray-1">Tìm thấy {{ danhSachQuyenTotalCount }} kết quả</p>
      <DataTable
        :value="danhSachQuyenNoiBo"
        :loading="isLoadingTable"
        responsiveLayout="scroll"
        :auto-layout="false"
        style="overflow-x: auto"
        :selection.sync="selectedPermission"
        rowGroupMode="rowspan"
        groupRowsBy="permissionId"
        :rowClass="rowClass"
      >
        <Column
          field="permissionId"
          dataKey="stt"
          headerStyle="width: 40px"
          headerClass="p-2"
          header="STT"
          bodyStyle="text-align: center"
        >
          <template #filter> </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.stt }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="permissionId"
          header="Mã quyền"
          headerStyle="width: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.name"
              @change="filterDanhSachQuyen"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.name }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="permissionId"
          header="Tên quyền"
          headerStyle="width: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.displayName"
              @change="filterDanhSachQuyen"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.displayName }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="nhomVaiTro"
          header="Nhóm/Vai trò"
          headerStyle="width: 200px"
          bodyStyle="padding: 0!important"
          bodyClass="col-nhom-vai-tro"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.nhomVaiTro"
              @change="filterDanhSachQuyen"
            />
          </template>
          <template #body="slotProps">
            <div class="p-2">
              {{ slotProps.data.groupRole }}
            </div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="isActive"
          header=""
          bodyStyle="padding: 0!important"
          headerStyle="width: 40px; padding: 10px"
          bodyClass="col-active"
        >
          <template #header="">
            <Checkbox
              v-model="requestInformation.activeRole"
              :binary="true"
              v-b-popover.hover.top="'Chọn quyền'"
              disabled="true"
            />
          </template>
          <template #body="slotProps">
            <div class="d-flex justify-content-center">
              <Checkbox
                :value="slotProps.data.id"
                v-model="slotProps.data.isActive"
                v-b-popover.hover.top="'Chọn quyền'"
                :binary="true"
                @change="activePermission(slotProps.data)"
                :disabled="
                  slotProps.data.isDisable ||
                  readonly ||
                  !hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.PHAN_QUYEN)
                "
              />
            </div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="doiTuongPhamVi"
          header="Đối tượng phạm vi"
          headerStyle="width: 240px"
          bodyStyle="padding: 0!important"
          bodyClass="col-doi-tuong-pham-vi"
        >
          <template #body="slotProps">
            <div class="p-2">
              <div style="margin-bottom: -0.5rem">
                <Checkbox
                  :disabled="true"
                  class="mb-2"
                  name="city"
                  :binary="true"
                  v-model="slotProps.data.isLevel"
                />
                <label class="d-inline-flex ml-2 mr-3">Level</label>
                <Checkbox
                  :disabled="true"
                  class="mb-2"
                  name="city"
                  :binary="true"
                  v-model="slotProps.data.isPhamVi"
                />
                <label class="d-inline-flex ml-2 mr-3">Cơ cấu tổ chức</label>
              </div>
            </div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="phamVi"
          header="Phạm vi"
          headerStyle="width: 250px"
          bodyStyle="padding: 0!important"
          bodyClass="col-pham-vi"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestInformation.phamVi"
              @change="filterDanhSachQuyen"
            />
          </template>
          <template #body="slotProps">
            <div class="p-2 pt-0">
              <div
                v-if="
                  slotProps.data.listPhamVi && slotProps.data.listPhamVi.length
                "
                class="d-flex justify-content-end"
              >
                <b-icon
                  icon="diagram-3"
                  variant="primary"
                  class="cursor-pointer"
                  @click="slotProps.data.viewByDonVi = true"
                  v-b-popover.hover.top="'Xem theo đơn vị'"
                ></b-icon>
                <b-icon
                  icon="person-circle"
                  class="cursor-pointer ml-2"
                  @click="slotProps.data.viewByDonVi = false"
                  v-b-popover.hover.top="'Xem theo cá nhân'"
                ></b-icon>
                <b-icon
                  class="ml-2 cursor-pointer"
                  icon="x-circle"
                  v-if="
                    !slotProps.data.isDisable &&
                    slotProps.data.listPhamVi &&
                    slotProps.data.listPhamVi.length
                  "
                  scale="1"
                  variant="danger"
                  v-b-popover.hover.top="'Xóa phạm vi quyền'"
                  @click="xoaPhamViQuyen(slotProps.data)"
                ></b-icon>
              </div>
              <div
                v-show="!slotProps.data.viewByDonVi"
                v-for="(item, index) in slotProps.data.listPhamVi.filter(
                  (x) => x.canBo
                )"
                :key="index"
              >
                <div>
                  <span>{{ item.canBo }}</span>
                  <b-icon
                    v-if="!slotProps.data.isDisable && !readonly"
                    icon="x"
                    class="cursor-pointer text-danger"
                    @click="removeItemObjectPermission(slotProps.data, item)"
                  ></b-icon>
                </div>
              </div>
              <div
                v-show="slotProps.data.viewByDonVi"
                v-for="(item, index) in slotProps.data.listPhamVi.filter(
                  (x) => !x.canBo
                )"
                :key="index"
              >
                <div>
                  <span>{{ item.moTaLevel || item.donVi }}</span>
                  <b-icon
                    v-if="!slotProps.data.isDisable"
                    icon="x"
                    class="cursor-pointer text-danger"
                    @click="removeItemObjectPermission(slotProps.data, item)"
                  ></b-icon>
                </div>
              </div>
            </div>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="thaoTac"
          header="Thao tác"
          v-if="hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.PHAN_QUYEN)"
          headerStyle="width: 100px"
          :filter-header-class="readonly ? 'd-none' : ''"
          :body-class="readonly ? 'd-none' : ''"
          :header-class="readonly ? 'd-none' : ''"
        >
          <template #body="slotProps">
            <div class="text-center">
              <b-icon
                class="mr-1 cursor-pointer"
                icon="pencil-square"
                scale="1.1"
                v-if="!slotProps.data.isDisable"
                v-b-popover.hover.top="'Cập nhật phạm vi quyền'"
                @click="moFormCapNhatPhamVi(slotProps.data)"
              ></b-icon>
              <font-awesome-icon
                icon="cogs"
                v-if="
                  slotProps.data.listPhamVi && slotProps.data.listPhamVi.length
                "
                class="mr-1 cursor-pointer"
                v-b-popover.hover.top="
                  'Cài đặt phạm vi quyền cho danh sách quyền'
                "
                @click="moFormThemQuyenVaoNguoiDung(slotProps.data)"
              />
              <b-icon
                class="mr-1 cursor-pointer"
                icon="plus-circle-fill"
                v-if="slotProps.data.canAppendRow"
                scale="1"
                variant="success"
                v-b-popover.hover.top="'Thêm quyền cho người dùng'"
                @click="appendRow(slotProps.data)"
              ></b-icon>
              <b-icon
                class="mr-1 cursor-pointer"
                icon="x-circle-fill"
                v-if="slotProps.data.canRemoveRow"
                scale="1"
                variant="danger"
                v-b-popover.hover.top="'Xóa quyền khỏi người dùng'"
                @click="showXoaQuyenKhoiNguoiDungModal(slotProps.data)"
              ></b-icon>
            </div>
          </template>
        </Column>
        <template #empty
          ><div class="text-center">Không có dữ liệu</div></template
        >
        <template #loading
          ><div class="text-center">Đang tải dữ liệu ...</div>
        </template>
      </DataTable>
      <BasePagination
        class="mt-3"
        :current-page="requestInformation.pageIndex"
        :total-pages="danhSachQuyenTotalPage"
        :total-rows="danhSachQuyenTotalCount"
        @changeNum="onChangeNum($event)"
        @changePages="onChangePages($event)"
      />
    </div>
    <ModalConfirmTitle
      title="Bạn có muốn xóa quyền khỏi người dùng?"
      ref="modalConfirmTitle"
      @confirmed="xoaActorMapping"
    />
    <CapNhatPhamViModal
      ref="CapNhatPhamViModal"
      :id="'cap-nhat-quyen-nguoi-dung-modal'"
      :deletePermissionIds="deletePermissionIds"
      :chiTietPhanQuyen="chiTietPhanQuyen"
      :actorId="chiTietNguoiDung.userCanBoDepartmentDefaultId"
      :actorType="ACTOR_TYPE_DATA.USER_CANBO_DEPARTMENT"
      @refreshData="layDanhSachQuyenTheoNguoiDung"
    />
    <XoaQuyenThuocNguoiDungModal
      :permissionName="chiTietPhanQuyen.name"
      :deletePermissionIds="deletePermissionIds"
      @xoaQuyen="xoaPhamViQuyenNguoiDung"
    />
    <b-modal
      ref="themQuyenVaoNguoiDungModal"
      centered
      title="Cài đặt phạm vi quyền"
      size="xl"
      :hide-footer="true"
    >
      <DanhSachQuyenKhongThuocNguoiDung
        ref="danhSachQuyenKhongThuocNguoiDung"
        @themQuyenVaoNguoiDungThanhCong="themQuyenVaoNguoiDungThanhCong"
        @hideModal="hideModal"
        :key="`danh-sach-quyen-${chiTietNguoiDung.Id}`"
        :appId="appId"
        :actorId="chiTietNguoiDung.userCanBoDepartmentDefaultId"
        :actorType="ACTOR_TYPE_DATA.USER_CANBO_DEPARTMENT"
        :chiTietPhanQuyen="chiTietPhanQuyen"
      />
    </b-modal>
  </div>
</template>

<script>
import _cloneDeep from "lodash/cloneDeep";
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import { BANG_DANH_SACH_QUYEN, ACTOR_TYPE_DATA } from "@/constants/constants";
import _isNil from "lodash/isNil";
import XoaQuyenThuocNguoiDungModal from "@/components/pages/quan-tri-he-thong/quyen/XoaQuyenThuocNguoiDungModal";
import DanhSachQuyenKhongThuocNguoiDung from "@/components/pages/quan-tri-he-thong/quyen/DanhSachQuyenKhongThuocNguoiDung";
import { removeAccents } from "@/utils/normalize";
import CapNhatPhamViModal from "@/components/pages/quan-tri-he-thong/quyen/CapNhatPhamViModal";
import BasePagination from "@/components/common/BasePagination";
import ModalConfirmTitle from "@/components/modal/ModalConfirmTitle";
import { hasPermissionUser } from "@/utils/permissionUtils";
import { PERMISSION_NAME } from "@/constants/constants";

export default {
  name: "DanhSachQuyenTheoNguoiDung",
  components: {
    XoaQuyenThuocNguoiDungModal,
    DanhSachQuyenKhongThuocNguoiDung,
    CapNhatPhamViModal,
    BasePagination,
    ModalConfirmTitle,
  },
  data() {
    return {
      PERMISSION_NAME,
      danhSachQuyenTheoNguoiDung: [],
      danhSachQuyenNoiBo: [],
      isLoadingTable: false,
      allPermissions: false,
      deletePermissionIds: [],
      NguoiDungId: null,
      selectAllRowsInPage: false,
      ACTOR_TYPE_DATA,
      emptyHeaderTable: [
        BANG_DANH_SACH_QUYEN.stt,
        BANG_DANH_SACH_QUYEN.name,
        BANG_DANH_SACH_QUYEN.displayName,
        BANG_DANH_SACH_QUYEN.appName,
        BANG_DANH_SACH_QUYEN.thaoTac,
      ],
      selectedPermission: [],
      requestInformation: {
        pageIndex: 1,
        pageSize: 10,
        displayName: "",
        name: "",
        nhomVaiTro: "",
        phamVi: "",
      },
      chiTietPhanQuyen: {},
      danhSachQuyenTotalCount: 0,
      danhSachQuyenTotalPage: 0,
    };
  },
  props: {
    chiTietNguoiDung: {
      type: Object,
      required: true,
    },
    readonly: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Boolean | null,
      required: false,
    },
    appId: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      danhSachQuyen: "user/danhSachQuyenTheoNguoiDung",
      danhSachApp: "app/tatCaApp",
    }),
    hasPageData() {
      return !_isEmpty(this.danhSachQuyen);
    },
    danhSachAppNoiBo() {
      if (
        this.danhSachApp &&
        this.chiTietNguoiDung &&
        this.chiTietNguoiDung.applicationIds
      ) {
        return this.danhSachApp.filter((x) =>
          this.chiTietNguoiDung.applicationIds.includes(x.id)
        );
      } else {
        return [];
      }
    },
  },
  watch: {
    appId: {
      handler() {
        this.layDanhSachQuyenTheoNguoiDung();
      },
      deep: true,
    },
    chiTietNguoiDung: {
      handler() {
        if (!_isNil(this.chiTietNguoiDung)) {
          this.NguoiDungId = this.chiTietNguoiDung.id;
          this.layDanhSachQuyenTheoNguoiDung();
        }
      },
      deep: true,
    },
    danhSachQuyen: {
      handler() {
        this.danhSachQuyenNoiBo = this.layDanhSachQuyenNoiBo(
          this.danhSachQuyen
        );
      },
      immediate: true,
    },
    selectAllRowsInPage: {
      handler() {
        this.clickSelectAllRowInPage();
      },
    },
  },
  created() {},
  methods: {
    hasPermissionUser,
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachQuyenTheoNguoiDung();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.layDanhSachQuyenTheoNguoiDung();
    },
    appendRow(rowData) {
      let data = _cloneDeep(rowData);
      data.actorMappingId = null;
      data.isActive = false;
      this.activePermission(data, true);
    },
    rowClass(rowData) {
      if (rowData.isDisable) {
        return "disabled-background";
      }
      return "";
    },
    activePermission(data, isReloadData) {
      console.clear();
      const $vm = this;
      let payload = {
        actorId: this.chiTietNguoiDung.userCanBoDepartmentDefaultId,
        actorMappingId: data.actorMappingId,
        permissionId: data.permissionId,
        isActive: data.isActive,
        actorType: ACTOR_TYPE_DATA.USER_CANBO_DEPARTMENT,
      };
      this.isLoadingTable = true;
      this.$store
        .dispatch("permission/activePermission", payload)
        .then((res) => {
          this.isLoadingTable = false;
          if (res.data.succeeded) {
            $vm.$toasted.clear();
            $vm.$toasted.global.showSuccessMessage({
              message: res.data.message,
            });
            if (isReloadData) {
              $vm.layDanhSachQuyenTheoNguoiDung();
            }
          } else {
            $vm.$toasted.clear();
            $vm.$toasted.global.showErrorMessage({
              message: res.data.message,
            });
            data.isActive = !data.isActive;
            $vm.layDanhSachQuyenTheoNguoiDung();
          }
        })
        .catch((err) => {
          this.isLoadingTable = false;
          console.log(err);
          data.isActive = !data.isActive;
          $vm.layDanhSachQuyenTheoNguoiDung();
        });
    },
    removeItemObjectPermission(rowData, itemData) {
      console.clear();
      const $vm = this;
      let payload = {
        actorId: this.chiTietNguoiDung.userCanBoDepartmentDefaultId,
        objectPermissionId: itemData.objectPermissionId,
        actorMappingId: itemData.actorMappingId,
        actorType: ACTOR_TYPE_DATA.USER_CANBO_DEPARTMENT,
      };
      this.isLoadingTable = true;
      this.$store
        .dispatch("permission/removeItemObjectPermission", payload)
        .then((res) => {
          this.isLoadingTable = false;
          if (res.data.succeeded) {
            $vm.$toasted.clear();
            $vm.$toasted.global.showSuccessMessage({
              message: res.data.message,
            });
            let index = rowData.listPhamVi.indexOf(itemData);
            rowData.listPhamVi.splice(index, 1);
            rowData.isLevel = res.data.data.isLevel;
            rowData.isPhamVi = res.data.data.isPhamVi;
            rowData.canRemoveRow = res.data.data.canRemoveRow;
          } else {
            $vm.$toasted.clear();
            $vm.$toasted.global.showErrorMessage({
              message: res.data.message,
            });
            $vm.layDanhSachQuyenTheoNguoiDung();
          }
        })
        .catch((err) => {
          this.isLoadingTable = false;
        });
    },
    moFormThemQuyenVaoNguoiDung(data) {
      this.chiTietPhanQuyen = data;
      this.$refs["themQuyenVaoNguoiDungModal"].show();
    },
    hideModal() {
      this.$refs["themQuyenVaoNguoiDungModal"].hide();
    },
    themQuyenVaoNguoiDungThanhCong() {
      this.$refs["themQuyenVaoNguoiDungModal"].hide();
      this.layDanhSachQuyenTheoNguoiDung();
    },
    showXoaQuyenKhoiNguoiDungModal(data) {
      this.chiTietPhanQuyen = data;
      this.$refs.modalConfirmTitle.showModal();
    },
    xoaActorMapping() {
      const $vm = this;
      let payload = {
        actorMappingId: this.chiTietPhanQuyen.actorMappingId,
        actorType: ACTOR_TYPE_DATA.USER_CANBO_DEPARTMENT,
      };
      this.isLoadingTable = true;
      this.$store
        .dispatch("permission/xoaActorMapping", payload)
        .then((res) => {
          this.isLoadingTable = false;
          if (res.data.succeeded) {
            $vm.$toasted.clear();
            $vm.$toasted.global.showSuccessMessage({
              message: res.data.message,
            });
            this.$refs.modalConfirmTitle.hideModal();
            this.layDanhSachQuyenTheoNguoiDung();
          } else {
            $vm.$toasted.clear();
            $vm.$toasted.global.showErrorMessage({
              message: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.isLoadingTable = false;
        });
    },
    xoaPhamViQuyen(data) {
      this.chiTietPhanQuyen = data;
      this.$bvModal.show("xoa-quyen-theo-nguoi-dung");
    },
    xoaPhamViQuyenNguoiDung() {
      const $vm = this;
      let payload = {
        actorMappingId: this.chiTietPhanQuyen.actorMappingId,
        actorType: ACTOR_TYPE_DATA.USER_CANBO_DEPARTMENT,
      };
      this.isLoadingTable = true;
      this.$store
        .dispatch("permission/xoaPhamViQuyen", payload)
        .then((res) => {
          this.isLoadingTable = false;
          if (res.data.succeeded) {
            $vm.$toasted.clear();
            $vm.$toasted.global.showSuccessMessage({
              message: res.data.message,
            });
            this.$bvModal.hide("xoa-quyen-theo-nguoi-dung");
            this.chiTietPhanQuyen.listPhamVi = [];
            this.chiTietPhanQuyen.isLevel = false;
            this.chiTietPhanQuyen.isPhamVi = false;
            this.chiTietPhanQuyen.canRemoveRow = res.data.data.canRemoveRow;
          } else {
            $vm.$toasted.clear();
            $vm.$toasted.global.showErrorMessage({
              message: res.data.message,
            });
            this.xoaPhamViQuyenThanhCong();
          }
        })
        .catch((err) => {
          this.isLoadingTable = false;
        });
    },
    xoaPhamViQuyenThanhCong() {
      this.$bvModal.hide("xoa-quyen-theo-nguoi-dung");
      this.layDanhSachQuyenTheoNguoiDung();
    },
    layDanhSachQuyenTheoNguoiDung() {
      if (this.chiTietNguoiDung.userCanBoDepartmentDefaultId && this.appId) {
        let payload = {
          userId: this.chiTietNguoiDung.id,
          AppId: this.appId,
          userCanBoDepartmentId:
            this.chiTietNguoiDung.userCanBoDepartmentDefaultId,
        };
        this.isLoadingTable = true;
        this.$store
          .dispatch("user/layDanhSachQuyenTheoNguoiDung", payload)
          .then(() => {
            this.isLoadingTable = false;
          });
      } else {
        this.danhSachQuyenNoiBo = [];
        this.danhSachQuyenTotalCount = 0;
      }
    },

    moFormCapNhatPhamVi(data) {
      this.chiTietPhanQuyen = data;
      if (data.isDisable) {
        this.chiTietPhanQuyen = {};
      }
      this.$refs["CapNhatPhamViModal"].showModal();
    },
    xoaQuyen() {
      console.log("Xóa quyền");
    },
    filterDanhSachQuyen() {
      this.requestInformation.pageIndex = 1;
      this.layDanhSachQuyenTheoNguoiDung();
    },
    layDanhSachQuyenNoiBo(danhSachQuyenTheoNguoiDung) {
      if (_isEmpty(danhSachQuyenTheoNguoiDung)) {
        return [];
      }
      let danhSachQuyen = danhSachQuyenTheoNguoiDung.map((item) => {
        let phamViSearchField = "";
        item.listPhamVi.forEach((e) => {
          phamViSearchField += e.canBo || e.donVi || e.moTaLevel;
        });
        return {
          checkbox: null,
          id: _isNil(item) ? "" : item.id,
          name: _isNil(item) ? "" : item.name,
          displayName: _isNil(item) ? "" : item.displayName,
          appName: _isNil(item.appName) ? "" : item.appName,
          groupRole: item.groupName || item.roleName,
          isLevel: item.isLevel,
          canAppendRow: item.canAppendRow,
          canRemoveRow: item.canRemoveRow,
          isPhamVi: item.isPhamVi,
          isDisable: item.isDisable,
          isActive: item.isActive,
          listPhamVi: item.listPhamVi,
          actorMappingId: item.actorMappingId,
          permissionId: item.permissionId,
          viewByDonVi: true,
          thaoTac: null,
          phamViSearchField: phamViSearchField,
        };
      });
      if (this.requestInformation.displayName !== "") {
        danhSachQuyen = danhSachQuyen.filter((x) =>
          removeAccents(x.displayName)
            .toLowerCase()
            .includes(
              removeAccents(this.requestInformation.displayName).toLowerCase()
            )
        );
      }
      if (this.requestInformation.name !== "") {
        danhSachQuyen = danhSachQuyen.filter((x) =>
          removeAccents(x.name)
            .toLowerCase()
            .includes(removeAccents(this.requestInformation.name).toLowerCase())
        );
      }
      if (this.requestInformation.nhomVaiTro !== "") {
        danhSachQuyen = danhSachQuyen.filter((x) =>
          removeAccents(x.groupRole)
            .toLowerCase()
            .includes(
              removeAccents(this.requestInformation.nhomVaiTro).toLowerCase()
            )
        );
      }
      if (this.requestInformation.phamVi !== "") {
        danhSachQuyen = danhSachQuyen.filter((x) =>
          removeAccents(x.phamViSearchField)
            .toLowerCase()
            .includes(
              removeAccents(this.requestInformation.phamVi).toLowerCase()
            )
        );
      }

      let danhSachIdQuyen = [
        ...new Set(danhSachQuyen.map((x) => x.permissionId)),
      ];
      this.danhSachQuyenTotalPage =
        parseInt(danhSachQuyen.length / this.requestInformation.pageSize + 1) ||
        0;
      this.danhSachQuyenTotalCount = danhSachQuyen.length;

      let start =
        (this.requestInformation.pageIndex - 1) *
        this.requestInformation.pageSize;
      let end = start + this.requestInformation.pageSize;
      danhSachQuyen.forEach((item) => {
        item.stt = danhSachIdQuyen.indexOf(item.permissionId) + 1;
      });
      danhSachQuyen = danhSachQuyen.filter(
        (x) => x.stt > start && x.stt <= end
      );
      return danhSachQuyen;
    },
  },
};
</script>


